import Button from '@atlaskit/button';
import InformationIcon from '@atlaskit/icon/core/information';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import SectionMessage, {
  SectionMessageAction,
} from '@atlaskit/section-message';
import { Box } from '@fuegokit/react';
import { ReactNode, useState } from 'react';

import { usePersonalConfiguration } from '../screens/PersonalConfigurationProvider';
import { TOGGL_PROFILE_LINK } from './AddTokenForm';

export const TOGGL_API_LIMITS_DOCS_LINK =
  'https://support.toggl.com/en/articles/11484112-api-webhook-limits';

const LINK_ICON_COLOR = 'var(--ds-link)';

const openTogglProfile = () => window.open(TOGGL_PROFILE_LINK, '_blank');

export function UsageConfirmationGate({
  children,
}: Readonly<{ children: ReactNode }>) {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const { config } = usePersonalConfiguration();

  if (!isConfirmed && !config.hideApiLimitsWarningMessage) {
    return (
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        sx={{ gap: '16px' }}
      >
        <SectionMessage
          appearance="warning"
          title="Toggl request"
          actions={[
            <SectionMessageAction
              onClick={openTogglProfile}
              key="request-quota-link"
            >
              Toggl API requests quota{' '}
              <LinkExternalIcon
                label="Open Toggl profile page"
                color={LINK_ICON_COLOR}
              />
            </SectionMessageAction>,
          ]}
        >
          <p>
            <a href={TOGGL_API_LIMITS_DOCS_LINK} target="_blank">
              Toggl API usage policy
            </a>
            . <br /> Loading app uses 1 request from organization and user
            specific hourly limits.
          </p>
        </SectionMessage>
        <Box
          sx={{
            pointerEvents: 'none',
            display: 'flex',
            gap: '4px',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <InformationIcon label="info-icon" color="var(--ds-icon-discovery)" />
          <span style={{ wordBreak: 'break-word', hyphens: 'auto' }}>
            By proceeding you acknowledge Toggl API usage
          </span>
        </Box>
        <Button
          appearance="primary"
          onClick={() => setIsConfirmed(true)}
          testId="proceed-button"
        >
          Proceed to app
        </Button>
      </Box>
    );
  }
  return <>{children}</>;
}
